'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CarouselProgress({
  selectedIndex,
  totalSlides,
}: {
  selectedIndex: number;
  totalSlides: number;
}) {
  return (
    <div className="flex h-1 w-full flex-1 items-center justify-start bg-border">
      <div
        className={cn('h-1 bg-black transition-all ease-in-out')}
        style={{ width: `${((selectedIndex + 1) / (totalSlides || 1)) * 100}%` }}
      />
    </div>
  );
}
